// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { solutionsCardStyles } from "@guestsupply/App/Components/SolutionsCard/SolutionsCard";
import { ellipsis } from "@guestsupply/XDL/Utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

solutionsCardStyles.itemsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 4px;
        padding: 16px;
        box-sizing: border-box;
        ${({ backgroundColor }: any) =>
            css`
                background: ${backgroundColor};
            `}
    `,
};
solutionsCardStyles.imageWrapper = {
    css: css`
        width: 110px;
        height: 110px;
    `,
};
solutionsCardStyles.image = {
    width: "110",
    height: "110",
    css: css`
        max-width: 100%;
        max-height: 100%;
        height: auto;
    `,
};

solutionsCardStyles.titleTypography = {
    variant: "h5",
    as: "p",
    css: css`
        min-height: 22px;
        margin: 30px 0 12px;
        ${ellipsis(1)}
    `,
};
solutionsCardStyles.button = {
    css: css`
        width: 100%;
    `,
    typographyProps: {
        css: css`
            margin: auto;
        `,
    },
};
